if (!customElements.get("m-icon-box-marquee")) {
  class MIconBoxMarquee extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.track = this.querySelector(".m-icon-box-marquee__track");
      if (!this.track) return;
      this.init();
    }

    init() {
      if (this.childElementCount === 1) {
        this.track.classList.add("m-icon-box-marquee__track--animated");

        for (let index = 0; index < 6; index++) {
          this.clone = this.track.cloneNode(true);
          this.clone.setAttribute("aria-hidden", true);
          this.appendChild(this.clone);
        }

        // pause when out of view
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this);
      }
    }

    scrollingPlay() {
      this.classList.remove("m-icon-box-marquee--paused");
    }

    scrollingPause() {
      this.classList.add("m-icon-box-marquee--paused");
    }
  }

  customElements.define("m-icon-box-marquee", MIconBoxMarquee);
}
